var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",class:[_vm.isSmall, _vm.isNoBorder, _vm.isMedium, _vm.isBigger],style:([_vm.customStyle, _vm.image])})}
var staticRenderFns = []

export { render, staticRenderFns }